module.exports = __webpack_public_path__ + "img/20190924154219360截图20190924145853040.19532597.jpg";